var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid w-100 d-print-none",attrs:{"alt":' county Indiana banner image',"src":_vm.baseUrl + _vm.corpcode + '.webp',"width":"1020","height":"129"}})}
var staticRenderFns = []

export { render, staticRenderFns }